export const blacklist = (str: string, chars: string): string => {
  return str.replace(new RegExp(`[${chars}]+`, "g"), "");
};
